const AlertConstants = {
  LOAD_OPERATION_CHECKS: "expalert/LOAD_OPERATION_CHECKS",
  LOADING_OPERATION_CHECKS: "expalert/LOADING_OPERATION_CHECKS",
  LOADED_OPERATION_CHECKS: "expalert/LOADED_OPERATION_CHECKS",
  LOAD_EXPERIMENT_JOURNAL: "expalert/LOAD_EXPERIMENT_JOURNAL",
  LOADING_EXPERIMENT_JOURNAL: "expalert/LOADING_EXPERIMENT_JOURNAL",
  LOADED_EXPERIMENT_JOURNAL: "expalert/LOADED_EXPERIMENT_JOURNAL",
  LOAD_ALERT_RESOLVE_REASONS: "expalert/LOAD_ALERT_RESOLVE_REASONS",
  LOADING_ALERT_RESOLVE_REASONS: "expalert/LOADING_ALERT_RESOLVE_REASONS",
  LOADED_ALERT_RESOLVE_REASONS: "expalert/LOADED_ALERT_RESOLVE_REASONS",
  LOAD_QUALITY_ALERTS: "expalert/LOAD_QUALITY_ALERTS",
  LOADING_QUALITY_ALERTS: "expalert/LOADING_QUALITY_ALERTS",
  LOADED_QUALITY_ALERTS: "expalert/LOADED_QUALITY_ALERTS",
  RESOLVE_QUALITY_ALERTS: "expalert/RESOLVE_QUALITY_ALERTS",
  RESOLVING_QUALITY_ALERTS: "expalert/RESOLVING_QUALITY_ALERTS",
  RESOLVED_QUALITY_ALERTS: "expalert/RESOLVED_QUALITY_ALERTS",
  TOGGLE_VIEW_AND_RESOLVE_ALERTS: "expalert/TOGGLE_VIEW_AND_RESOLVE_ALERTS"
};
export {
  AlertConstants as default
};
//# sourceMappingURL=AlertConstants.js.map
